var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeRingL = function SvgEyeRingL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 41,
    height: 33,
    viewBox: "0 0 0.77 0.62",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315910163936"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.66.43C.69.44.6.5.57.51.35.64.25.56.07.42.25.27.42.27.66.43zM.72.23C.64.11.58.1.44.1.39.1.31.1.25.12M.06.21.05.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2.02c.07.04.08.09.08.14a.18.18 0 0 1-.06.09C.19.27.16.28.12.27.07.27.03.23.01.16-.02.07.03.05.08.02h.01C.1.01.12 0 .14 0 .16 0 .18 0 .2.02zM.16.08C.28.15.12.27.08.14.07.1.1.1.12.08c.02 0 .03-.01.04 0z",
    fill: "#000"
  })))));
};

export default SvgEyeRingL;